// extracted by mini-css-extract-plugin
module.exports = {"container":"DeviceHeader_container__39Zes","selector":"DeviceHeader_selector__3dn72","input":"DeviceHeader_input__1JvTT"};